/*
 * @Author: shiguang
 * @Date: 2024-04-19 14:42:09
 * @LastEditors: yusha
 * @LastEditTime: 2024-06-07 13:17:00
 * @Description:
 */
import { atom } from 'jotai';
import { request } from '@/config/request';
import { getMergedToken } from '@/config/request/interceptors';
import { ShopLocalstorage, TokenSignLocal } from '@/config/request/login';

const clearToken = () => {
	window.localStorage.removeItem(TokenSignLocal);
	window.localStorage.removeItem(ShopLocalstorage);
};
const getUserData = async (accessToken: string) => {
	try {
		const res =
			await request.customer.getCustomerDetails.getCustomerDetails();
		if (res.code !== '0') {
			clearToken();
			return undefined;
		}
		return res.data;
	} catch (e) {
		// 发现过期了或者其他错误了 让用户重新登录，清楚之前的脏数据，防止污染其他接口
		clearToken();
		return undefined;
	}
};

export const atomUserDetail = atom(
	async () => {
		const token = getMergedToken();
		if (token) {
			return getUserData(token);
		}
		return undefined;
	},
	async (get, set, accessToken: string) => {
		return getUserData(accessToken);
	}
);
